module.exports = __webpack_public_path__ + "static/media/animated_ashish2.7bbf3b72.png";